import { InvoiceLinkModalComponent } from '@teem/invoices-module/modals/invoice-link-modal/invoice-link-modal.component';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, ValidationErrors } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import * as moment from 'moment';

import { StoreInformationService } from '@teem/services/store-information.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ACTIONS as INVOICE_ACTIONS, TAX_TYPES } from '@teem/constants/invoice';
import { ONLINE_PAYMENT_LIMIT as _ONLINE_PAYMENT_LIMIT } from '@teem/constants/invoice';
import { Select2Directive } from "@teem/directives/select2.directive";
import { InvoiceService } from '@teem/services/invoice.service';
import { LoaderService } from '@teem/services/loader.service';
import { environment } from '@teem/environments/environment';
import { parseDate, copyText } from '@teem/helpers/functions';

import { InvoiceDeliverableForm } from '@teem/model-forms/invoice-deliverable-form';
import { InvoiceDeliverable } from '@teem/models/invoice-deliverable';
import { InvoiceForm } from '@teem/model-forms/invoice-form';
import { Invoice } from '@teem/models/invoice';

import { messages as i18n } from "@teem/constants/messages";
import { UserService } from '@teem/app/core/services/user.service';
import * as COUNTRIES from '@teem/constants/country';


@Component({
  selector: 'recall-invoice-form',
  templateUrl: './recall-invoice.component.html',
  styleUrls: ['./recall-invoice.component.scss']
})
export class RecallInvoiceComponent implements OnInit {
  @Output() onCreate: EventEmitter<any> = new EventEmitter();
  @Output() changeTab: EventEmitter<any> = new EventEmitter();
  @Input() invoiceDetail;
  @Input() userInfo: any;

  invoiceForm: FormGroup;
  deliverables: FormArray;
  deliverableForm: FormGroup;

  taxIncludeList: Array<object> = TAX_TYPES;
  selectedType: string = $localize`:@@ts.common.not_applicable:Not Applicable`;
  submitted: boolean = false;
  prevInvoice: boolean = false;
  productAndServices: any;
  defaultAdditionalInfo: string = '';
  defaultPaymentInfo: any = {};
  showSaveBtn: boolean = false;
  qrCodeBase64: string = '';
  selectedClient: any;
  COUNTRIES: any = COUNTRIES;
  discountType: string = 'percentage';

  constructor(
    private elRef: ElementRef,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private loaderService: LoaderService,
    private invoiceService: InvoiceService,
    private userService: UserService,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit(): void {
    this.invoiceForm = this.fb.group(new InvoiceForm(new Invoice()))
    this.deliverableForm = this.fb.group(new InvoiceDeliverableForm(new InvoiceDeliverable));

    let node = this.elRef.nativeElement.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
    node.parentElement.classList.remove("simplified-invoice");
    node.parentElement.classList.remove("simplified-invoice--shadow");

    // console.log('invoiceDetail', this.invoiceDetail);
    if (this.invoiceDetail) {
      this.selectedClient = {
        id: this.invoiceDetail?.client.id,
        full_name: this.invoiceDetail?.client.full_name,
        email: this.invoiceDetail?.client.email
      }

      this.invoiceForm.get('invoice_type').setValue(this.invoiceDetail?.invoice_type);
      this.invoiceForm.get('buyer_first_name').setValue(this.invoiceDetail?.buyer_first_name);
      this.invoiceForm.get('buyer_last_name').setValue(this.invoiceDetail?.buyer_last_name);
      this.invoiceForm.get('buyer_address').setValue(this.invoiceDetail?.buyer_address);
      this.invoiceForm.get('buyer_vat_number').setValue(this.invoiceDetail?.buyer_vat_number);
      this.invoiceForm.get('buyer_cr_number').setValue(this.invoiceDetail?.buyer_cr_number);

      this.invoiceForm.get('invoice_number').setValue(this.invoiceDetail?.next_invoice_number);
      this.invoiceForm.get('client_id').setValue(this.invoiceDetail?.client.id);
      this.invoiceForm.get('discount').setValue(this.invoiceDetail?.discount);
      this.invoiceForm.get('discounted_amount').setValue(this.invoiceDetail?.discounted_amount);

      this.invoiceForm.get('discount_type').setValue(this.invoiceDetail?.discount_type);
      if (this.invoiceDetail?.discount_type == "amount") {
        this.discountType = "amount";
      } else {
        this.discountType = "percentage";
      }

      this.productAndServices = this.invoiceDetail?.items;

      if (this.invoiceDetail?.tax_percent > 0) {
        this.invoiceForm.get('tax_percent').setValue(this.invoiceDetail?.tax_percent ? this.invoiceDetail?.tax_percent : 0);
        this.invoiceForm.get('include_tax').setValue(true);
        this.enableTax(true);
      } else {
        this.invoiceForm.get('include_tax').setValue(false);
        this.enableTax(false);
        this.invoiceForm.get('tax_type').setValue(3);
      }

      if (this.invoiceDetail?.tax_type) {
        let result: any = this.taxIncludeList.filter((item: any) => item.id == this.invoiceDetail?.tax_type);
        this.selectedType = result[0].name;
        this.invoiceForm.get('tax_type').setValue(result[0].id);
      }
    }
    this.userService.getSetting({ key: ['payment_info', 'additional_info'] }).subscribe((data: any) => {
      this.defaultAdditionalInfo = data.additional_info ? data.additional_info : '';
      if (this.userInfo.accept_bank_transfer) {
        this.defaultPaymentInfo = data.payment_info ? data.payment_info : {};
      }
    })
  }

  get invoiceDeliveryFeeAmount() {
    return this.invoiceDetail?.delivery_fee;
  }

  deliverableCost(deliverableValues: any) {
    let value = deliverableValues.quantity * deliverableValues.rate;
    if (!isNaN(value)) {
      return value;
    }
    return 0;
  }

  get subTotalDeliverableCost(){
    let items = this.deliverables ? this.deliverables.value : [];
    if (items && items.length > 0) {
      return items.reduce((a, b) => a + this.deliverableCost(b), 0);
    }
    return 0;
  }

  get taxAmount() {
    let items = this.deliverables ? this.deliverables.value : [];
    if (items && items.length > 0) {
      if (this.discountType == 'percentage') {
        return items.reduce((a, b) => a + this.deliverableTaxWithDiscountAmount(b), 0);
      }
      let itemsTotal = items.reduce((a, b) => a + this.deliverableCost(b), 0);
      return this.deliverableTaxWithDiscountByAmount(itemsTotal);
    }
    return 0;
  }

  deliverableTaxWithDiscountAmount(deliverable: any) {
    let itemTotal = deliverable.quantity * deliverable.rate;
    let discountAmount = this.invoiceDetail?.discount; // this.invoiceForm.get('discount').value;
    discountAmount = parseFloat(discountAmount).toFixed(2);
    if (discountAmount > 0) {
      if (this.discountType == 'percentage') {
        discountAmount = ((itemTotal / (100) * (discountAmount)));
      }
    } else {
      discountAmount = 0;
    }
    
    let value = itemTotal - discountAmount;
    if (this.invoiceDetail?.tax_type == 2) {
      if ((this.invoiceDetail?.tax_percent && deliverable.is_taxable)) {
        return ((value / (1 + this.invoiceDetail?.tax_percent / 100)) * (this.invoiceDetail?.tax_percent / 100))
      }
      return 0;
    } else if (this.invoiceDetail?.tax_type == 3) {
      return 0;
    }
    return (this.invoiceDetail?.tax_percent && deliverable.is_taxable) ? (value * this.invoiceDetail?.tax_percent / 100) : 0;
  }

  deliverableTaxWithDiscountByAmount(itemTotal: any) {
    let discountAmount = Number(this.invoiceForm.get('discount').value);
    discountAmount = -Math.abs(discountAmount).toFixed(2);    
    let value = itemTotal - discountAmount;
    if (this.invoiceDetail?.tax_type == 2) {
      if ((this.invoiceDetail?.tax_percent)) {
        return ((value / (1 + this.invoiceDetail?.tax_percent / 100)) * (this.invoiceDetail?.tax_percent / 100))
      }
      return 0;
    } else if (this.invoiceDetail?.tax_type == 3) {
      return 0;
    }
    return (this.invoiceDetail?.tax_percent) ? (value * this.invoiceDetail?.tax_percent / 100) : 0;
  }

  calculateOriginalAmount() {
    this.invoiceForm.get('original_amount').setValue(this.invoiceOriginalAmount);
  }

  calculateDiscountedAmount() {
    this.invoiceForm.get('discounted_amount').setValue(this.invoiceDiscountAmount);
  }

  calculateDeliveryAmount() {
    this.invoiceForm.get('delivery_fee').setValue(this.invoiceDeliveryFeeAmount);
  }

  get taxInvoice() {
    if(this.taxAmount || (this.invoiceDetail.tax_type == 1 || this.invoiceDetail.tax_type == 2)){
      return true;
    }
    return false;
  }

  get invoiceTotalValue(){
    let items = this.deliverables ? this.deliverables.value : [];
      if (items && items.length > 0) {
        return items.reduce((a, b) => a + this.deliverableCost(b), 0);
      }
      return 0;
  }

  get invoiceSubTotal() {
    return ((this.taxAmount) ? (this.invoiceTotalValue - this.taxAmount) : this.invoiceTotalValue);
  }

  get invoiceOriginalAmount() {
    return (this.subTotalDeliverableCost - this.invoiceDiscountAmount);
  }

  // get invoiceOriginalAmount() {

  //   if (this.invoiceForm.get('discount').value > 0) {
  //     let items = this.deliverables ? this.deliverables.value : [];
  //     if (items && items.length > 0) {
  //       return items.reduce((a, b) => a + this.deliverableCost(b), 0);
  //     }
  //     return null;
  //   } else {
  //     return null;
  //   }
  // }

  // get invoiceDiscountAmount() {
  //   if (this.invoiceForm.get('discount').value > 0) {
  //     return (((this.invoiceOriginalAmount) / (100) * (this.invoiceForm.get('discount').value)));
  //   } else {
  //     return null;
  //   }

  // }

  get invoiceDiscountAmount() {
    let discountAmount = this.invoiceDetail?.discount;
    discountAmount = parseFloat(discountAmount).toFixed(2);
    if (this.discountType != 'percentage') {
      // return this.invoiceDetail?.discounted_amount;
      return -Math.abs(this.invoiceDetail?.discounted_amount);
    } else if (discountAmount > 0) {
      return (((this.subTotalDeliverableCost) / (100) * (discountAmount)));
    }
    return 0;
  }

  get taxAmountToInvoiceTotal() {
    if (this.invoiceDetail?.tax_type == 1) {
      let items = this.deliverables ? this.deliverables.value : [];
      if (items && items.length > 0) {
        if (this.discountType == 'percentage') {
          return items.reduce((a, b) => a + this.deliverableTaxWithDiscountAmount(b), 0);
        }
        let itemsTotal = items.reduce((a, b) => a + this.deliverableCost(b), 0);
        return this.deliverableTaxWithDiscountByAmount(itemsTotal);
      }
    }
    return 0;
  }

  // get invoiceTotal() {
  //   if (this.invoiceDetail.discount > 0) {
  //     return ((this.invoiceOriginalAmount) - (this.invoiceDiscountAmount));
  //   } else {
  //     let items = this.deliverables ? this.deliverables.value : [];
  //     if (items && items.length > 0) {
  //       return items.reduce((a, b) => a + this.deliverableCost(b), 0);
  //     }
  //     return 0;
  //   }
  // }

  get invoiceTotal() {
    let value = this.invoiceOriginalAmount;
    if (this.invoiceDetail?.tax_percent) {
      if (this.invoiceDetail?.tax_type == 3 || this.invoiceDetail?.tax_type == 2) {
        value = value;
      } else {
        value = value + Number(this.taxAmountToInvoiceTotal);
      }      
    }
    return value + Number(this.invoiceDeliveryFeeAmount);
  }

  // get invoiceTotal() {
  //   let items = this.deliverables ? this.deliverables.value : [];
  //   if (items && items.length > 0) {
  //     return items.reduce((a, b) => a + this.deliverableCost(b), 0);
  //   }
  //   return 0;
  // }

  get subTotal() {
    if (this.invoiceTotal) {

      let taxPercent = 0;
      if (this.invoiceForm.get('include_tax').value)
        taxPercent = this.invoiceForm.get('tax_percent').value;

      if (this.invoiceDetail?.tax_type == 2) { //Inclusive of Tax
        return taxPercent ? (this.invoiceTotal - (this.invoiceTotal / (1 + taxPercent / 100))) : this.invoiceTotal;
      }
      return taxPercent ? (this.invoiceTotal + this.invoiceTotal * taxPercent / 100) : this.invoiceTotal;
    }

    return 0;
  }

  // get taxAmount() {
  //   let items = this.deliverables ? this.deliverables.value : [];
  //   if (items && items.length > 0) {
  //     return items.reduce((a, b) => a + this.deliverableTax(b), 0);
  //   }
  //   return 0;
  // }

  deliverableTax(deliverable: any) {
    const invoiceFormValues = this.invoiceForm.value;
    if (this.invoiceDetail?.tax_type == 2) {
      return (invoiceFormValues.tax_percent && deliverable.is_taxable) ? (((Math.abs(deliverable.quantity) * deliverable.rate) / (1 + invoiceFormValues.tax_percent / 100)) * (invoiceFormValues.tax_percent / 100)) : 0;
    } else if (this.invoiceDetail?.tax_type == 3) {
      return 0;
    }
    return (invoiceFormValues.tax_percent && deliverable.is_taxable) ? (Math.abs(deliverable.quantity) * deliverable.rate * invoiceFormValues.tax_percent / 100) : 0;
  }

  // deliverableCost(deliverableValues: any) {
  //   let value = deliverableValues.quantity * deliverableValues.rate;

  //   const invoiceFormValues = this.invoiceForm.value;

  //   if (!isNaN(value)) {

  //     if (invoiceFormValues.tax_percent && deliverableValues.is_taxable) {
  //       if (this.invoiceDetail?.tax_type == 2 || this.invoiceDetail?.tax_type == 3) {
  //         value = value;// + (value / (1 + (invoiceFormValues.tax_percent / 100)));
  //       } else {
  //         value = value + value * invoiceFormValues.tax_percent / 100;
  //       }
  //     }
  //     return value;
  //   }
  //   return 0;
  // }

  addDeliverable(form: FormGroup) {
    let items = this.deliverables ? this.deliverables.value : [];
    const index = items.findIndex((e) => e.title === form.value.title);
    if (index === -1) {
      form.value.available_quantity = (form.value.available_quantity == undefined || form.value.available_quantity == null) ? undefined : form.value.available_quantity;
      const currentDeliverbles = this.invoiceForm.get('items') as FormArray
      currentDeliverbles.push(
        this.fb.group(
          new InvoiceDeliverableForm(new InvoiceDeliverable(form.value))
        )
      )

      this.deliverables = this.invoiceForm.get('items') as FormArray;

      setTimeout(() => {
        if (this.invoiceDetail?.tax_percent > 0) {
          this.enableTax(true);
        }
        form.controls.is_taxable.setValue((this.invoiceDetail?.tax_percent > 0) ? 1 : 0);
      }, 100);
    } else {
      this.changeQuantity(this.deliverables.controls[index], 'plus');
    }

    // document.getElementById('create-deliverable').querySelector('input').focus();
  }

  enableTax(value: boolean) {
    let taxPercentControl = this.invoiceForm.get('tax_percent');
    if (value) {
      taxPercentControl.setValidators([Validators.required]);
    } else {
      taxPercentControl.setValue(null);
      taxPercentControl.clearValidators();
    }
    taxPercentControl.updateValueAndValidity();

    const deliverables = this.invoiceForm.get('items') as FormArray;

    let control;
    for (control of deliverables?.controls) {
      control.controls.is_taxable.setValue(value ? 1 : 0);
    }

    this.deliverableForm.controls.is_taxable.setValue(value ? 1 : 0);
    this.deliverables = deliverables;
  }

  saveAsDraft() {
    if (this.validate()) {
      this.invoiceForm.get('is_draft').setValue(1);
      this.invoiceForm.get('action').setValue('draft');
      this.submit();
    }
  }

  saveAsPdf() {
    if (this.validate()) {
      try {
        this.invoiceForm.get('is_draft').setValue(0);
        this.invoiceForm.get('action').setValue('pdf');
        this.submit();
        // (window as any).open(`${environment.baseUrl}/download/invoice/${data.uuid}/pdf?lang=${(window as any).LOCALE}`, '_self', 'location=yes');
      } catch (err) {
        console.error('promise error')
      }
    }
  }

  saveAndEmail() {
    if (this.validate()) {
      this.invoiceForm.get('is_draft').setValue(0);
      this.invoiceForm.get('action').setValue(INVOICE_ACTIONS.EMAIL);
      this.submit();
    }
  }

  saveAndWhatsapp() {
    if (this.validate()) {
      this.invoiceForm.get('is_draft').setValue(0);
      this.invoiceForm.get('action').setValue(INVOICE_ACTIONS.WHATSAPP);
      this.submit();
    }
  }

  saveAndShareLink() {
    if (this.validate()) {
      this.invoiceForm.get('is_draft').setValue(0);
      this.invoiceForm.get('action').setValue(INVOICE_ACTIONS.SHARE_LINK);
      this.submit();
    }
  }

  saveInvoice() {
    if (this.validate()) {
      this.invoiceForm.get('is_draft').setValue(0);
      this.invoiceForm.get('action').setValue(null);
      this.submit();
    }
  }

  getItemSubTotal(deliverable) {
    const invoiceFormValues = this.invoiceForm.value;
    if (invoiceFormValues.tax_type == 2) {
      return ((deliverable.quantity * deliverable.rate)) / (1 + (invoiceFormValues.tax_percent / 100));
    } else {
      return deliverable.quantity * deliverable.rate;
    }
  }

  validate() {
    this.showSaveBtn = false;
    this.prevInvoice = false;
    let deliverables = this.invoiceForm.get('items').value;
    if (deliverables.length == 0) {
      Swal.fire({
        title: i18n.warning,
        text: i18n.invoice.please_add_deliverable,
        icon: 'warning'
      })
    } else {
      this.submitted = true;
      if (this.invoiceForm.valid) {
        return true
      }
    }

    return false;
  }

  changeInputQuantityIfValueNullOrZero(deliverable) {
    let value = deliverable.controls.quantity.value;

    if (value == null || value <= 0) {
      deliverable.controls.quantity.setValue(1);
    }

  }

  removeDeliverable(index: number) {
    const currentDeliverables = this.invoiceForm.get('items') as FormArray

    currentDeliverables.removeAt(index)
    this.deliverables = currentDeliverables;
  }


  changeInputQuantity(deliverable) {
    let value = deliverable.controls.quantity.value;
    // console.log("this.deliverables.value ", deliverable.value);

    if (deliverable?.value?.available_quantity < value) {
      Swal.fire({
        title: i18n.warning,
        text: i18n.invoice.out_of_stock,
        icon: 'warning'
      })
      deliverable.controls.quantity.setValue(deliverable?.value?.available_quantity);
    }

  }

  changeQuantity(deliverable, type) {
    let value = deliverable.controls.quantity.value;
    if (type == 'plus') {
      // console.log(deliverable?.value?.available_quantity);
      if (deliverable?.value?.available_quantity <= value) {
        Swal.fire({
          title: i18n.warning,
          text: i18n.invoice.out_of_stock,
          icon: 'warning'
        })
        return false;
      }
      deliverable.controls.quantity.setValue(value + 1);
    } else if (type == 'minus' && value > 1) {
      deliverable.controls.quantity.setValue(value - 1);
    }
  }

  private submit() {
    this.calculateOriginalAmount();
    this.calculateDiscountedAmount();
    this.calculateDeliveryAmount();
    this.invoiceForm.get('total_amount').setValue(this.invoiceTotal);
    this.invoiceForm.get('parent_invoice_id').setValue(this.invoiceDetail?.invoice_id);
    return new Promise((resolve, reject) => {
      this.loaderService.startLoading();

      let fd: any = this.invoiceForm.value;
      fd.parent_invoice_id = this.invoiceDetail?.invoice_id;
      fd.tax_type = this.invoiceDetail?.tax_type??null;
      fd.invoice_date = parseDate(fd.invoice_date);

      // Create Invoice
      this.invoiceService.create(fd).subscribe((r) => {
        this.loaderService.stopLoading();

        let msg = i18n.invoice.invoice_saved;
        let result: any = r;

        if (fd.action == INVOICE_ACTIONS.WHATSAPP) {
          msg = i18n.invoice.invoice_saved_and_whatsapp_sent;
        } else if (fd.action == INVOICE_ACTIONS.EMAIL) {
          msg = i18n.invoice.invoice_saved_and_email_sent
        } else if (fd.action == INVOICE_ACTIONS.SHARE_LINK) {
          msg = i18n.invoice.invoice_saved
          // msg = result.url;
          // copyText(msg);
        }

        Swal.fire(i18n.done, msg, 'success').then(() => {
          if (result.url)
            this.generateInvoiceLink(result.url);

          if (fd.action == 'pdf' && result.uuid) {
            // (window as any).open(`${environment.baseUrl}/download/invoice/${result.uuid}/pdf?lang=${(window as any).LOCALE}`, '_self');
            (window as any).open(`${environment.baseUrl}/download-invoice/${this.invoiceDetail.uuid}/pdf?lang=${(window as any).LOCALE}`, '_blank');
          }
          this.invoiceForm = this.fb.group(new InvoiceForm(new Invoice()))
          this.deliverables = this.invoiceForm.get('items') as FormArray;

          this.onCreate.emit(fd);
        });
        this.submitted = false;
        resolve(r);
      }, (err) => {
        this.loaderService.stopLoading();

        // Set server side error
        if (err.status === 422) {
          if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;

            Object.keys(validationErrors).forEach((prop) => {
              this.invoiceForm.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    });
  }


  generateInvoiceLink(invoiceUrl) {
    const modalRef = this.modalService.open(InvoiceLinkModalComponent);

    // Set id on modal dialog
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "quick-payment";
    modalRef.componentInstance.invoiceUrl = invoiceUrl;
    modalRef.componentInstance.onSuccess = () => {

    };

    modalRef.result.then(result => {

    }, fallbackResult => {

    })
  }

  isTaxPresent(): boolean {
    this.invoiceDetail.tax_percent == null ? this.invoiceDetail.tax_percent = 0 : this.invoiceDetail.tax_percent;
    return this.invoiceDetail.tax_percent == 0 ? false : true;
  }

  get prefTextColor() {
    return `${this.userInfo.preference.text_color} !important;`;
  }

  openPreviewModal() {
    this.prevInvoice = true;
    // Object.assign(this.invoiceDetail, this.invoiceForm.value);
    // console.log(this.invoiceDetail);
    this.elRef.nativeElement.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentElement.classList.add("simplified-preview");
    this.calculateOriginalAmount();
    this.calculateDiscountedAmount();
    this.calculateDeliveryAmount();
    this.invoiceForm.get('parent_invoice_id').setValue(this.invoiceDetail?.invoice_id);
    this.invoiceDetail = this.invoiceForm.value;
    this.invoiceDetail.invoice_id = this.invoiceDetail.parent_invoice_id
    this.invoiceDetail.client = this.selectedClient;
    this.invoiceDetail.invoice_date = parseDate(this.invoiceDetail.invoice_date);

    if (this.userInfo.country_id == COUNTRIES.SAUDI_ARABIA) {
      this.invoiceService.getInvoiceQrCode(this.invoiceDetail).subscribe((data: any) => {
        this.loaderService.stopLoading();
        if (data.status == 'success') {
          this.qrCodeBase64 = data.qr_code_base64;
        }
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  closeModel() {
    // if (this.prevInvoice) {
    //   this.prevInvoice = false;
    // } else {
      this.changeTab.emit('all-invoices')
    // }
  }

  toggleSaveBtn() {
    this.showSaveBtn = true;
  }

  setInvoiceWidth(condition) {
    $("#left-section-pdf").hide();
    $("#left-section-invoice").hide();
    $(".invoice-screen-type").removeClass("active");
    $(".page-size").removeClass('page-size--mobile');
    $(".page-size").removeClass('page-size--pdf');
    $(".prev-invoice__bottomInfo").removeClass("prev-invoice__bottomInfo--mobile");
    $("body").removeClass("mobile--size");
    $("body").removeClass("pdf--size");
    $("body").removeClass("web--size");

    if (condition == "mobile") {
      $(".ist-1").addClass("active");
      $(".page-size").addClass('page-size--mobile');
      $(".prev-invoice__bottomInfo").addClass('prev-invoice__bottomInfo--mobile');
      $("body").addClass("mobile--size");
      $("#left-section-invoice").show();
    } else if (condition == "web") {
      $(".ist-3").addClass("active");
      $("body").addClass("web--size");
      $("#left-section-invoice").show();
    } else if (condition == "pdf") {
      $("#left-section-pdf").hide();
      $(".page-size").addClass('page-size--pdf');
      var invoice, node = document.getElementsByClassName("prev-invoice__leftSection")[0];
      $(".prev-invoice__editsave").toggle(); 

      $("body").addClass("pdf--size");
      $("#left-section-pdf").show(); 
      $(".ist-2").addClass("active");
    }
  }

}
